module.exports = __webpack_public_path__ + "img/seminar_symposium_body.3a5f448d.jpg";